var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./MaterialsPopup.jinja');
require('./MaterialsPopup.less');

var CommonStory = require('front/components/CommonStory/CommonStory');


module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
    }, BasePopup.prototype.baseEvents),


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonStory': {selector: '.CommonStory', viewConstructor: CommonStory}
    },


    apiUrl: function () {
        return Urls['submissions:api:materials'](this.category, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        this.category = this.options.category;

        BasePopup.prototype.initialize.call(this, options);
    },


    renderData: function () {
        return {
            popup: this.data || {}
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/pages/MaterialsPopup/MaterialsPopup.js
// module id = 132
// module chunks = 0